import React from "react"
import { ErrorMessage as FormikErrorMessage } from "formik"

const ErrorMessage = ({ name, className }) => (
	<FormikErrorMessage name={name}>
		{msg => (
			<div className={`mt-8 text-crayola ${className || ""}`}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="inline-block h-[14px] w-[14px] fill-current">
					<path
						fillRule="evenodd"
						d="M7 1.75a5.25 5.25 0 1 1 0 10.5 5.25 5.25 0 0 1 0-10.5Zm.583 7.583H6.417V10.5h1.166V9.333Zm0-5.833H6.417v4.667h1.166V3.5Z"
					/>
				</svg>
				<span className="ml-2 text-xs">{msg}</span>
			</div>
		)}
	</FormikErrorMessage>
)

export default ErrorMessage
